import { ChangeEvent } from "react";
import { Box } from "@material-ui/core";
import {
  AddVersions,
  MobileVersionInfo,
  MobileVersionList,
} from "../../MobileVersions/MobileVersions.style";
import { ButtonCustom } from "../Style/Style";

interface VersionFormProps {
  title: string;
  value: string;
  disabled: boolean;
  lastVersion: string;
  lastDate: string;
  onChange(e: ChangeEvent<HTMLInputElement>): void;
  onSave(): void;
}

export const VersionFormBlock = ({
  title,
  value,
  onChange,
  onSave,
  disabled,
  lastVersion,
  lastDate,
}: VersionFormProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="32%"
    >
      <h2>{title}</h2>
      <Box display="flex">
        <AddVersions
          value={value}
          label="Введіть версію"
          multiline
          fullWidth
          onChange={onChange}
        />
        <ButtonCustom disabled={disabled} onClick={onSave}>
          Зберегти
        </ButtonCustom>
      </Box>

      <MobileVersionList>
        <Box mt={2} display="flex" justifyContent="space-between">
          <MobileVersionInfo>{lastVersion}</MobileVersionInfo>
          <MobileVersionInfo>{lastDate}</MobileVersionInfo>
        </Box>
      </MobileVersionList>
    </Box>
  );
};
